import React from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from 'url-lib';
import {
    getUserMenuInfo,
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
} from '@eb/site-header';
import { utils } from '@eb/core-manage';
import GlobalHeader from 'eventbrite_design_system/globalHeader/GlobalHeader';
import {
    getResourcesMenu,
    getMarketingLinks,
    getSalesLinks,
    getMarketingSignInLink,
} from './utils';

const LOGO_COLOR = 'ui-orange';
const { getOrganizerLogoInfo } = utils;

export default class MarketingHeader extends React.Component {
    static propTypes = {
        env: ENV_SHAPE_PROP_TYPE.isRequired,
        request: REQUEST_SHAPE_PROP_TYPE.isRequired,
        user: USER_SHAPE_PROP_TYPE.isRequired,
        requestPath: PropTypes.string.isRequired,
    };

    render() {
        const { env, user, requestPath, featureFlags } = this.props;
        const {
            serverUrl,
            ebDomain,
            adminServerUrl,
            logoutUrl,
            isManageOverviewActive,
        } = env;

        const { isAuthenticated } = user;
        const marketingLinks = getMarketingLinks({
            serverUrl,
            requestPath,
            ebDomain,
        });
        const salesLinks = getSalesLinks({ serverUrl, requestPath, ebDomain });
        const resourcesMenu = getResourcesMenu({ serverUrl, requestPath, env });
        const { signupUrl } = env;
        const marketingSignupUrl = formatUrl(signupUrl, {
            referrer: '/create',
        });
        const nonUserQuickLinks = [
            ...salesLinks,
            ...(getMarketingSignInLink(
                requestPath,
                isAuthenticated,
                marketingSignupUrl,
                ebDomain,
            ) || []),
        ];
        const logoInfo = getOrganizerLogoInfo({
            url: serverUrl,
            requestPath,
            iconColor: LOGO_COLOR,
        });

        return (
            <GlobalHeader
                logoInfo={logoInfo}
                userMenuInfo={getUserMenuInfo({
                    serverUrl,
                    adminServerUrl,
                    logoutUrl,
                    requestPath,
                    user,
                    isManageOverviewActive,
                    featureFlags,
                })}
                nonUserQuickLinks={nonUserQuickLinks}
                quickLinks={marketingLinks}
                additionalMenus={resourcesMenu}
                useNarrowBreakpoint={true}
            />
        );
    }
}
